<template>
    <div v-loading="loading" v-if="loading" class="loading">
    </div>

    <div class="backpage" @click="goBack" style="cursor: pointer;">
        <el-icon>
            <Back />
        </el-icon> 返回上一级
    </div>
    <div class="installt">
        <div class="intext">订单详情</div>
    </div>
    <div class="order">
        <div class="orderstatel">
            <div class="orderstate">
                <div class="ordertext">
                    <div class="orderimg">
                        <img src="../../assets/order/order1.png" alt="">

                    </div>
                    <div>{{ orderState(order.orderInfo.state) }}</div>
                </div>
                <div class="orderstore">
                    <div class="orderhead">
                        <div class="orderheads">
                            <img :src="images(order.productInfo.productImg)" alt="">
                        </div>
                        <div class="ordername">
                            <div :title="order.productInfo.productName"
                                style="width: 400px;  white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"> {{
        order.productInfo.productName }} </div>
                            <div class="jianjie">
                                {{ order.productSpec }}
                            </div>
                        </div>
                    </div>
                    <div class="ordernuber">
                        <div class="nmber">
                            <div>积分{{ order.orderInfo.pfen }}</div>
                            <div class="jianjie">数量: {{ order.productInfo.productNum }}</div>
                        </div>
                    </div>

                </div>
                <div class="fahuo">
                    <div class="overandfahuo">
                        <div v-if="order.orderInfo.state != 40" class="over" @click="complete" >标记为已完成 </div>
                        <div v-if="order.orderInfo.state == 20" class="now" @click="handleClose">现在去发货</div>
                    </div>

                </div>
            </div>
            <div class="orderstated">
                <div class="ordertext">
                    <div class="orderimg">
                        <img src="../../assets/order/order1.png" alt="">

                    </div>
                    <div>{{ orderStates(order.productInfo.productImg) }}</div>
                </div>
                <div class="xiaoji">
                    <!-- <div class="xiaojis">
                        <div class="xiaoname">
                            <div class="xiao">用户总积分</div>
                            <div></div>
                        </div>
                        <div>{{order.productInfo.pfen}}</div>
                    </div> -->
                    <div class="xiaojis">
                        <div class="xiaoname">
                            <div class="xiao">消耗积分</div>
                            <div></div>
                        </div>
                        <div>- {{ order.orderInfo.pfen }}</div>
                    </div>

                    <!-- <div class="xiaojis">
                        <div class="xiaoname">
                            <div class="xiao" style="color: #111827;">剩余总积分</div>
                            <div></div>
                        </div>
                        <div>{{ 0 }}</div>
                    </div> -->
                </div>
                <div class="yifu">
                    <div style="font-size: 18px;color: #718096;">买家已支付</div>
                    <div style="font-size: 22px;color: #111827;">积分{{ order.orderInfo.pfen }}</div>
                </div>
            </div>
        </div>
        <div class="Buyer">
            <div class="bMessages">
                <div>买家信息</div>
                <div class="maihead">
                    <div class="header">
                        <div class="hea">
                            <img src="" alt="">
                        </div>
                        <div class="hname">
                            <div>{{ order.orderInfo.userName || '未知' }}</div>
                            <div class="memngl">门铃号:{{ order.orderInfo.uid || '未知' }}</div>
                        </div>
                    </div>
                    <div class="tongz">
                        <el-icon color="#409EFC" :size="24">
                            <Message />
                        </el-icon>
                    </div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>

                <div class="hname">
                    <div>联系信息</div>
                    <div class="memngl"><el-icon>
                            <Phone />
                        </el-icon> {{ order.receiptInfo.pointTelphone || '未知' }}</div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
                <div class="hname">
                    <div>收货地址</div>
                    <div class="memngl"><el-icon>
                            <Location />
                        </el-icon> {{ order.receiptInfo.pointAddress || '暂无' }}</div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
            </div>
            <div class="bian">
                <div class="hname">
                    <div>订单编号：{{ order.orderInfo.psn || '未知' }}</div>
                    <div>下单时间：{{ datahuan(order.orderInfo.paymentTime) }}</div>
                    <div>快递单号：{{ order.orderInfo.pShippingcode || '未知' }}</div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
                <div class="hname">
                    <div>支付方式：{{ '积分支付' }}</div>
                    <div>付款时间：{{ datahuan(order.orderInfo.time) }}</div>
                </div>
                <div style=" width: 100%;height: 1px;border-top: 1px solid #F1F2F4;margin: 24px 0;"></div>
                <div class="hname">
                    <div>备注</div>
                    <div class="memngl"> {{ order.receiptInfo.buyMessage ? order.receiptInfo.buyMessage : '买家暂无备注' }}
                    </div>
                </div>

            </div>

        </div>
    </div>
    <el-dialog v-model="openfahuonow" title="提示" width="500" :before-close="dialogVisible = false">
        <span>请选择快递公司:</span> &nbsp;


        <el-autocomplete v-model="getDelivery" :fetch-suggestions="querySearch" clearable class="inline-input w-50"
            placeholder="请选择快递公司" @select="handleSelect" /> <br>
        <br>
        <span>请输入快递单号:</span> &nbsp; <el-input v-model="danhao" style="width: 240px" placeholder="请输入快递单号" />
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="openfahuonow = false">取消</el-button>
                <el-button type="primary" @click="kuaidfahuo">
                    确定
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script setup>
import { useStore } from 'vuex'
import { ref } from 'vue'
import stores from '@/api/store';

import { ElMessage, ElMessageBox } from 'element-plus'

const store = useStore()
let order = ref(store.state.jfstore)
console.log(order) // 打印 state 中的 storeId


const openfahuonow = ref(false)
let getDeliveryCompanyList = ref([])
let getDelivery = ref('')
let danhao = ref('')

const handleClose = async () => {
    openfahuonow.value = true
    const res = await stores.getDeliveryCompanyList()
    // getDeliveryCompanyList.value = res.date

    getDeliveryCompanyList.value = Object.entries(res.data).map(([key, value]) => ({ value: value, table: key }));
    console.log('getDeliveryCompanyList', getDeliveryCompanyList.value)

}
const querySearch = (queryString, cb) => {
    console.log(queryString)
    const results = queryString ? createFilter(queryString) : getDeliveryCompanyList.value
    console.log(results)

    cb(results)
}
const createFilter = (queryString) => {
    // let asc = []
    const asc = getDeliveryCompanyList.value.filter(item => item.value.includes(queryString));
    console.log(asc)

    return asc
}
let CompanyCode = null
const handleSelect = (item) => {
    console.log(item)
    getDelivery.value = item.value
    CompanyCode = item.table
}
const kuaidfahuo = async () => {
    if (CompanyCode || danhao.value) {
        loading.value = true
        openfahuonow.value = false
        let storeId = order.value.orderInfo.storeId
        let orderId = order.value.orderInfo.id
        let params = {
            storeId,
            orderId,
            deliveryNumber: danhao.value,
            deliveryType: 10,
            orderType: 3,
            deliveryCompanyCode: CompanyCode
        }
        const res = await stores.delivery(params)
        if (res.success) {
            loading.value = false
            oorder.value.orderInfo.state = 20
            ElMessage({
                message: '发货成功！',
                type: 'success',

            })
        } else {
            loading.value = false
            ElMessage.error(res.message)

        }
    } else {
        ElMessage({
            message: '请完善信息！',
            type: 'warning',

        })
    }



}
const complete = () => {
    ElMessageBox.confirm(
        '确定完成该订单？',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            completes()
        })
        .catch(() => {

        })
}
const completes = async () => {
    let orderId = order.value.orderInfo.id
    const res = await stores.complete(orderId, 3)
    console.log(res)
    if (res.success) {
        order.value.orderInfo.state = 40
        ElMessage({
            message: ' 此订单以修改为完成 ！',
            type: 'success',
        })
    } else {
        ElMessage.error(res.message)

    }
}
const images = (face) => {

    if (face) {
        const regex = /"(.*?)"/;
        const result = face.match(regex);
        // 输出提取的字符
        if (result && result[1]) {
            if (result[1].startsWith('http')) {
                return result[1]
            } else {
                if (result[1].startsWith('/')) {
                    return 'http://www.daomenkou.cn' + result[1]

                } else {
                    return 'http://www.daomenkou.cn/' + result[1]

                }
            }
        } else {
            console.log('未找到匹配的字符串');

            if (face.startsWith('http')) {
                return face
            } else {
                return 'http://www.daomenkou.cn/' + face
            }
        }
    } else {
        return require('../../assets/shop/morentx.png')
    }

}
let loading = ref(false)

// const openfahuonow = () => {
//     ElMessageBox.prompt('请输入单号', '提示', {
//         confirmButtonText: '确认',
//         cancelButtonText: '取消',
//         inputPattern:
//             /^[A-Za-z0-9]+$/,
//         inputErrorMessage: '请输入正确的单号',
//     })
//         .then(({ value }) => {
//             // ElMessage({
//             //     type: 'success',
//             //     message: `Your email is:${value}`,
//             // })
//             loading.value = true
//             fahuonow(value)
//         })
//         .catch(() => {

//         })
// }
const fahuonow = async (values) => {
    console.log(order.value)
    let storeId = order.value.orderInfo.storeId
    let orderId = order.value.orderInfo.id
    // let deliverNumber = order.value.orderInfo.osn

    const res = await stores.deliver(storeId, orderId, values, 3)
    console.log(res)
    if (res.success) {
        ElMessage({
            message: '发货成功！',
            type: 'success',
        })
        loading.value = false

    } else {
        // console.log(res.message)
        let message = res.message
        ElMessage.error(message)
        loading.value = false

    }
}
const datahuan = (days) => {
    const date = new Date(days * 1000);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDate;
}
const goBack = () => {
    window.history.back();
}
const payTypes = (payType) => {
    if (payType == 0) {
        return '华标支付'
    } else if (payType == 1) {
        return '微信支付'
    } else if (payType == 1) {
        return '支付支付'
    } else if (payType == 1) {
        return '门币支付'
    } else if (payType == 1) {
        return '竹子支付'
    } else if (payType == 1) {
        return '新闲钱宝'
    }
}
const orderState = (state) => {
    console.log('State', state)
    if (state == '0') {
        return '取消'
    } else if (state == '10') {
        return '待兑换'
    } else if (state == '15') {
        return '待审核'
    } else if (state == '20') {
        return '待发货'
    } else if (state == '30') {
        return '待收货'
    } else if (state == '40') {
        return '已完成'
    } else {
        return '未知'
    }
}
const orderStates = (State) => {
    if (State == '10' || State == '0') {
        return '未付款'
    } else if (State == '20' || State == '30' || State == '40' || State == '15') {
        return '已付款'
    } else {
        return '未知'
    }
}
</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
}

.installt {
    width: 820px;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }

}

.order {
    margin-top: 22px;
    height: calc(100% - 84px);
    border-radius: 16px;
    display: flex;

    .orderstatel {
        height: 100%;

        min-width: 720px;
        width: calc(100% - 396px);

        .orderstate {
            width: 100%;
            height: 347px;

            background-color: #fff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 0 34px;

            .ordertext {
                height: 92px;
                border-bottom: 1px solid #F1F2F4;
                display: flex;
                align-items: center;
                font-size: 18px;
                font-family: AppleSystemUIFont;
                color: #FE964A;

                .orderimg {
                    width: 34px;
                    height: 34px;
                    // background: #EBF3FF;
                    border-radius: 17px;
                    margin-right: 13px;
                    overflow: hidden;
                    img{
                        width: 100%;
                        height: 100%;

                    }
                }
            }

            .orderstore {
                width: 100%;
                height: 92px;
                background: #FAFAFA;
                border-radius: 8px;
                margin-top: 33px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 10px 0 18px;
                box-sizing: border-box;

                .orderhead {
                    display: flex;
                    justify-content: space-between;

                    .orderheads {
                        width: 60px;
                        height: 60px;
                        border-radius: 8px;
                        background: #cfd3da;
                        margin-right: 16px;
                        overflow: hidden;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .ordername {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 55px;
                        font-size: 18px;
                        color: #111827;

                        .jianjie {
                            font-size: 14px;
                            font-weight: 400;
                            color: #718096;
                        }
                    }

                }

                .ordernuber {


                    .nmber {
                        height: 55px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        font-size: 18px;
                        color: #111827;

                        .jianjie {
                            font-size: 14px;
                            font-weight: 400;
                            color: #718096;
                            text-align: right;
                        }
                    }

                }
            }

            .fahuo {
                margin-top: 34px;
                width: 100%;
                border-top: 1px solid #F1F2F4;
                height: 51px;
                padding-top: 20px;

                .overandfahuo {
                    display: flex;
                    align-items: center;
                    float: right;

                    .over {
                        width: 124px;
                        height: 51px;
                        background: #FFFFFF;
                        border: 1px solid #3686FF;
                        color: #3686FF;
                        border-radius: 8px;
                        text-align: center;
                        line-height: 51px;
                        cursor: pointer;

                    }

                    .now {
                        width: 124px;
                        height: 51px;
                        background: #FFFFFF;
                        border: 1px solid #3686FF;
                        background: #3686FF;
                        color: #FFFFFF;
                        line-height: 51px;
                        text-align: center;
                        border-radius: 8px;
                        margin-left: 17px;
                        cursor: pointer;
                    }

                }
            }
        }

        .orderstated {
            margin-top: 24px;
            width: 100%;
            height: calc(100% - 373px);
            // height: 100%;

            background-color: #fff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 0 34px;

            .ordertext {
                height: 92px;
                border-bottom: 1px solid #F1F2F4;
                display: flex;
                align-items: center;
                font-size: 18px;
                font-family: AppleSystemUIFont;
                color: #3686FF;

                .orderimg {
                    width: 34px;
                    height: 34px;
                    // background: #EBF3FF;
                    border-radius: 17px;
                    margin-right: 13px;
                    overflow: hidden;
                    img{
                        width: 100%;
                        height: 100%;

                    }
                }
            }

            .xiaoji {
                border-bottom: 1px solid #F1F2F4;
                padding-bottom: 16px;

                .xiaojis {
                    display: flex;
                    justify-content: space-between;
                    font-size: 18px;
                    font-weight: 400;
                    color: #718096;
                    margin-top: 24px;

                    .xiaoname {
                        display: flex;

                        .xiao {
                            width: 172px;
                            margin-right: 25px;
                        }
                    }
                }


            }

            .yifu {
                display: flex;
                justify-content: space-between;
                padding-top: 20px;
            }

        }
    }

    .Buyer {
        width: 396px;
        height: 100%;
        margin-left: 26px;

        .bMessages {
            width: 100%;
            height: 372px;
            background-color: #fff;
            border-radius: 8px;
            padding: 29px 30px 0 34px;
            box-sizing: border-box;

            .maihead {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;

                .header {
                    height: 52px;
                    width: 328px;
                    display: flex;

                    .hea {
                        width: 52px;
                        height: 52px;
                        background-color: #cfd3da;
                        border-radius: 26px;
                    }

                    .hname {
                        margin-left: 20px;
                        font-size: 18px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;

                        .memngl {
                            font-size: 14px;
                            font-weight: 400;
                            color: #718096;
                        }
                    }
                }
            }

            .hname {
                height: 52px;
                margin-left: 20px;
                font-size: 18px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                .memngl {
                    font-size: 14px;
                    font-weight: 400;
                    color: #718096;
                }
            }


        }

        .bian {
            width: 100%;
            height: calc(100% - 387px);
            min-height: 340px;
            background-color: #fff;
            margin-top: 15px;
            border-radius: 8px;
            padding: 29px 0 0 34px;
            box-sizing: border-box;

            .hname {
                height: 62px;
                margin-left: 20px;
                font-size: 16px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                .memngl {
                    font-size: 14px;
                    font-weight: 400;
                    color: #A0AEC0;
                }
            }
        }

    }
}

.loading {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}
</style>